export const generateRandomString = (
  length = 0,
  possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
) =>
  Array.from(Array(length)).reduce(
    result => result + possible.charAt(Math.floor(Math.random() * possible.length)),
    ''
  );

export const getCFDAppUrl = (app = 'retail-cfd') => {
  let baseAppUrl = `https://${app}.lightspeedapp.com`;

  if (['localhost', 'rad.localdev'].includes(window.location.hostname)) {
    baseAppUrl = `http://localhost:${app === 'retail-cfd' ? '3011' : '3010'}`;
  } else if (
    window.location.hostname.includes('lightspeedappstaging') ||
    window.location.hostname.includes('lightspeedappstg')
  ) {
    baseAppUrl = `https://${app}.lightspeedappstg.com`;
  }

  return baseAppUrl;
};

export const getBrandingConfig = async () => {
  const [background, logo] = await window.lsCloud.Options.get(['background_url', 'logo_url']);

  return {
    background,
    logo,
  };
};
